import { useNavigate } from "react-router-dom";
import { MASCOT } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <AuthShell title="Pagamento cancelado" subtitle="Sem problemas! Seu plano continua te esperando." mascot={MASCOT.tilt}>
      <div className="text-center space-y-4">
        <p className="text-sm text-[#5c4634]">Você cancelou o checkout. Quando quiser, é só escolher o plano de novo.</p>
        <button onClick={() => navigate("/")} className="btn-orange w-full py-3.5 rounded-full font-semibold" data-testid="cancel-back-home">Voltar aos planos</button>
      </div>
    </AuthShell>
  );
}
